export default [
  {alpha: 'AF', name: 'Afganistán'},
  {alpha: 'AX', name: 'Åland'},
  {alpha: 'AL', name: 'Albania'},
  {alpha: 'DE', name: 'Alemania'},
  {alpha: 'AD', name: 'Andorra'},
  {alpha: 'AO', name: 'Angola'},
  {alpha: 'AI', name: 'Anguilla'},
  {alpha: 'AQ', name: 'Antártida'},
  {alpha: 'AG', name: 'Antigua y Barbuda'},
  {alpha: 'SA', name: 'Arabia Saudita'},
  {alpha: 'DZ', name: 'Argelia'},
  {alpha: 'AR', name: 'Argentina'},
  {alpha: 'AM', name: 'Armenia'},
  {alpha: 'AW', name: 'Aruba'},
  {alpha: 'AU', name: 'Australia'},
  {alpha: 'AT', name: 'Austria'},
  {alpha: 'AZ', name: 'Azerbaiyán'},
  {alpha: 'BS', name: 'Bahamas'},
  {alpha: 'BD', name: 'Bangladés'},
  {alpha: 'BB', name: 'Barbados'},
  {alpha: 'BH', name: 'Baréin'},
  {alpha: 'BE', name: 'Bélgica'},
  {alpha: 'BZ', name: 'Belice'},
  {alpha: 'BJ', name: 'Benín'},
  {alpha: 'BM', name: 'Bermudas'},
  {alpha: 'BY', name: 'Bielorrusia'},
  {alpha: 'BO', name: 'Bolivia'},
  {alpha: 'BQ', name: 'Bonaire, San Eustaquio y Saba'},
  {alpha: 'BA', name: 'Bosnia y Herzegovina'},
  {alpha: 'BW', name: 'Botsuana'},
  {alpha: 'BR', name: 'Brasil'},
  {alpha: 'BN', name: 'Brunéi Darussalam'},
  {alpha: 'BG', name: 'Bulgaria'},
  {alpha: 'BF', name: 'Burkina Faso'},
  {alpha: 'BI', name: 'Burundi'},
  {alpha: 'BT', name: 'Bután'},
  {alpha: 'CV', name: 'Cabo Verde'},
  {alpha: 'KH', name: 'Camboya'},
  {alpha: 'CM', name: 'Camerún'},
  {alpha: 'CA', name: 'Canadá'},
  {alpha: 'QA', name: 'Catar'},
  {alpha: 'TD', name: 'Chad'},
  {alpha: 'CL', name: 'Chile'},
  {alpha: 'CN', name: 'China'},
  {alpha: 'CY', name: 'Chipre'},
  {alpha: 'VA', name: 'Ciudad del Vaticano'},
  {alpha: 'CO', name: 'Colombia'},
  {alpha: 'KM', name: 'Comoras'},
  {alpha: 'CG', name: 'Congo (Brazzaville)'},
  {alpha: 'CD', name: 'Congo (Kinsasa)'},
  {alpha: 'KR', name: 'Corea del Sur'},
  {alpha: 'CI', name: 'Costa de Marfil'},
  {alpha: 'CR', name: 'Costa Rica'},
  {alpha: 'HR', name: 'Croacia'},
  {alpha: 'CW', name: 'Curazao'},
  {alpha: 'DK', name: 'Dinamarca'},
  {alpha: 'DM', name: 'Dominica'},
  {alpha: 'EC', name: 'Ecuador'},
  {alpha: 'EG', name: 'Egipto'},
  {alpha: 'SV', name: 'El Salvador'},
  {alpha: 'AE', name: 'Emiratos Árabes Unidos'},
  {alpha: 'ER', name: 'Eritrea'},
  {alpha: 'SK', name: 'Eslovaquia'},
  {alpha: 'SI', name: 'Eslovenia'},
  {alpha: 'ES', name: 'España'},
  {alpha: 'US', name: 'Estados Unidos de América'},
  {alpha: 'EE', name: 'Estonia'},
  {alpha: 'ET', name: 'Etiopía'},
  {alpha: 'PH', name: 'Filipinas'},
  {alpha: 'FI', name: 'Finlandia'},
  {alpha: 'FJ', name: 'Fiyi'},
  {alpha: 'FR', name: 'Francia'},
  {alpha: 'GA', name: 'Gabón'},
  {alpha: 'GM', name: 'Gambia'},
  {alpha: 'GE', name: 'Georgia'},
  {alpha: 'GH', name: 'Ghana'},
  {alpha: 'GI', name: 'Gibraltar'},
  {alpha: 'GD', name: 'Granada'},
  {alpha: 'GR', name: 'Grecia'},
  {alpha: 'GL', name: 'Groenlandia'},
  {alpha: 'GP', name: 'Guadalupe'},
  {alpha: 'GU', name: 'Guam'},
  {alpha: 'GT', name: 'Guatemala'},
  {alpha: 'GF', name: 'Guayana Francesa'},
  {alpha: 'GG', name: 'Guernesey'},
  {alpha: 'GN', name: 'Guinea'},
  {alpha: 'GQ', name: 'Guinea Ecuatorial'},
  {alpha: 'GW', name: 'Guinea-Bisáu'},
  {alpha: 'GY', name: 'Guyana'},
  {alpha: 'HT', name: 'Haití'},
  {alpha: 'HN', name: 'Honduras'},
  {alpha: 'HK', name: 'Hong Kong'},
  {alpha: 'HU', name: 'Hungría'},
  {alpha: 'IN', name: 'India'},
  {alpha: 'ID', name: 'Indonesia'},
  {alpha: 'IQ', name: 'Irak'},
  {alpha: 'IR', name: 'Irán'},
  {alpha: 'IE', name: 'Irlanda'},
  {alpha: 'BV', name: 'Isla Bouvet'},
  {alpha: 'IM', name: 'Isla de Man'},
  {alpha: 'CX', name: 'Isla de Navidad'},
  {alpha: 'NF', name: 'Isla Norfolk'},
  {alpha: 'SH', name: 'Isla Santa Elena'},
  {alpha: 'IS', name: 'Islandia'},
  {alpha: 'KY', name: 'Islas Caimán'},
  {alpha: 'CC', name: 'Islas Cocos'},
  {alpha: 'CK', name: 'Islas Cook'},
  {alpha: 'FO', name: 'Islas Feroe'},
  {alpha: 'GS', name: 'Islas Georgias del Sur y Sandwich del Sur'},
  {alpha: 'HM', name: 'Islas Heard y McDonald'},
  {alpha: 'FK', name: 'Islas Malvinas'},
  {alpha: 'MP', name: 'Islas Marianas del Norte'},
  {alpha: 'MH', name: 'Islas Marshall'},
  {alpha: 'PN', name: 'Islas Pitcairn'},
  {alpha: 'SB', name: 'Islas Salomón'},
  {alpha: 'TC', name: 'Islas Turcas y Caicos'},
  {alpha: 'UM', name: 'Islas Ultramarinas Menores de los Estados Unidos'},
  {alpha: 'VG', name: 'Islas Vírgenes Británicas'},
  {alpha: 'VI', name: 'Islas Vírgenes de los Estados Unidos'},
  {alpha: 'IL', name: 'Israel'},
  {alpha: 'IT', name: 'Italia'},
  {alpha: 'JM', name: 'Jamaica'},
  {alpha: 'JP', name: 'Japón'},
  {alpha: 'JE', name: 'Jersey'},
  {alpha: 'JO', name: 'Jordania'},
  {alpha: 'KZ', name: 'Kazajistán'},
  {alpha: 'KE', name: 'Kenia'},
  {alpha: 'KG', name: 'Kirguistán'},
  {alpha: 'KI', name: 'Kiribati'},
  {alpha: 'KW', name: 'Kuwait'},
  {alpha: 'LA', name: 'Laos'},
  {alpha: 'LS', name: 'Lesoto'},
  {alpha: 'LV', name: 'Letonia'},
  {alpha: 'LB', name: 'Líbano'},
  {alpha: 'LR', name: 'Liberia'},
  {alpha: 'LY', name: 'Libia'},
  {alpha: 'LI', name: 'Liechtenstein'},
  {alpha: 'LT', name: 'Lituania'},
  {alpha: 'LU', name: 'Luxemburgo'},
  {alpha: 'MO', name: 'Macao'},
  {alpha: 'MK', name: 'Macedonia'},
  {alpha: 'MG', name: 'Madagascar'},
  {alpha: 'MY', name: 'Malasia'},
  {alpha: 'MW', name: 'Malaui'},
  {alpha: 'MV', name: 'Maldivas'},
  {alpha: 'ML', name: 'Malí'},
  {alpha: 'MT', name: 'Malta'},
  {alpha: 'MA', name: 'Marruecos'},
  {alpha: 'MQ', name: 'Martinica'},
  {alpha: 'MU', name: 'Mauricio'},
  {alpha: 'MR', name: 'Mauritania'},
  {alpha: 'YT', name: 'Mayotte'},
  {alpha: 'MX', name: 'México'},
  {alpha: 'FM', name: 'Micronesia'},
  {alpha: 'MD', name: 'Moldavia'},
  {alpha: 'MC', name: 'Mónaco'},
  {alpha: 'MN', name: 'Mongolia'},
  {alpha: 'ME', name: 'Montenegro'},
  {alpha: 'MS', name: 'Montserrat'},
  {alpha: 'MZ', name: 'Mozambique'},
  {alpha: 'MM', name: 'Myanmar'},
  {alpha: 'NA', name: 'Namibia'},
  {alpha: 'NR', name: 'Nauru'},
  {alpha: 'NP', name: 'Nepal'},
  {alpha: 'NI', name: 'Nicaragua'},
  {alpha: 'NE', name: 'Níger'},
  {alpha: 'NG', name: 'Nigeria'},
  {alpha: 'NU', name: 'Niue'},
  {alpha: 'NO', name: 'Noruega'},
  {alpha: 'NC', name: 'Nueva Caledonia'},
  {alpha: 'NZ', name: 'Nueva Zelanda'},
  {alpha: 'OM', name: 'Omán'},
  {alpha: 'NL', name: 'Países Bajos'},
  {alpha: 'PK', name: 'Pakistán'},
  {alpha: 'PW', name: 'Palaos'},
  {alpha: 'PS', name: 'Palestina'},
  {alpha: 'PA', name: 'Panamá'},
  {alpha: 'PG', name: 'Papúa Nueva Guinea'},
  {alpha: 'PY', name: 'Paraguay'},
  {alpha: 'PE', name: 'Perú'},
  {alpha: 'PF', name: 'Polinesia Francesa'},
  {alpha: 'PL', name: 'Polonia'},
  {alpha: 'PT', name: 'Portugal'},
  {alpha: 'PR', name: 'Puerto Rico'},
  {alpha: 'GB', name: 'Reino Unido'},
  {alpha: 'CF', name: 'República Centroafricana'},
  {alpha: 'CZ', name: 'República Checa'},
  {alpha: 'DO', name: 'República Dominicana'},
  {alpha: 'RE', name: 'Reunión'},
  {alpha: 'RW', name: 'Ruanda'},
  {alpha: 'RO', name: 'Rumanía'},
  {alpha: 'WS', name: 'Samoa'},
  {alpha: 'AS', name: 'Samoa Americana'},
  {alpha: 'BL', name: 'San Bartolomé'},
  {alpha: 'KN', name: 'San Cristóbal y Nieves'},
  {alpha: 'SM', name: 'San Marino'},
  {alpha: 'SX', name: 'San Martín (Países Bajos)'},
  {alpha: 'MF', name: 'San Martín (parte francesa)'},
  {alpha: 'PM', name: 'San Pedro y Miquelón'},
  {alpha: 'VC', name: 'San Vicente y las Granadinas'},
  {alpha: 'LC', name: 'Santa Lucía'},
  {alpha: 'ST', name: 'Santo Tomé y Príncipe'},
  {alpha: 'SN', name: 'Senegal'},
  {alpha: 'RS', name: 'Serbia'},
  {alpha: 'SC', name: 'Seychelles'},
  {alpha: 'SL', name: 'Sierra Leona'},
  {alpha: 'SG', name: 'Singapur'},
  {alpha: 'SY', name: 'Siria'},
  {alpha: 'SO', name: 'Somalia'},
  {alpha: 'LK', name: 'Sri Lanka'},
  {alpha: 'SZ', name: 'Suazilandia'},
  {alpha: 'ZA', name: 'Sudáfrica'},
  {alpha: 'SD', name: 'Sudán'},
  {alpha: 'SS', name: 'Sudán del Sur'},
  {alpha: 'SE', name: 'Suecia'},
  {alpha: 'CH', name: 'Suiza'},
  {alpha: 'SR', name: 'Surinam'},
  {alpha: 'SJ', name: 'Svalbard y Jan Mayen'},
  {alpha: 'TH', name: 'Tailandia'},
  {alpha: 'TW', name: 'Taiwán'},
  {alpha: 'TZ', name: 'Tanzania'},
  {alpha: 'TJ', name: 'Tayikistán'},
  {alpha: 'IO', name: 'Territorio Británico del Océano Índico'},
  {alpha: 'TF', name: 'Tierras Australes Francesas'},
  {alpha: 'TL', name: 'Timor Oriental'},
  {alpha: 'TG', name: 'Togo'},
  {alpha: 'TK', name: 'Tokelau'},
  {alpha: 'TO', name: 'Tonga'},
  {alpha: 'TT', name: 'Trinidad y Tobago'},
  {alpha: 'TN', name: 'Túnez'},
  {alpha: 'TM', name: 'Turkmenistán'},
  {alpha: 'TR', name: 'Turquía'},
  {alpha: 'TV', name: 'Tuvalu'},
  {alpha: 'UA', name: 'Ucrania'},
  {alpha: 'UG', name: 'Uganda'},
  {alpha: 'UY', name: 'Uruguay'},
  {alpha: 'UZ', name: 'Uzbekistán'},
  {alpha: 'VU', name: 'Vanuatu'},
  {alpha: 'VE', name: 'Venezuela'},
  {alpha: 'VN', name: 'Vietnam'},
  {alpha: 'WF', name: 'Wallis y Futuna'},
  {alpha: 'YE', name: 'Yemen'},
  {alpha: 'DJ', name: 'Yibuti'},
  {alpha: 'ZM', name: 'Zambia'},
  {alpha: 'ZW', name: 'Zimbabue'},
]
